<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('importTaxModel.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          { text: $t('importTaxModel.pageTitle'), active: true }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button
            v-if="canCreate"
            outline
            color="info"
            @click.prevent="showForm = true"
          >
            {{ $t('add_new') }}
          </ts-button>
          <ts-input
            v-model="search"
            :placeholder="$t('importTaxModel.search')"
            style="width: 250px"
          />
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.model }}</td>
          <td>{{ record.hs_code }}</td>
          <td class="text-right">{{ formatPercent(record.cpp_rate) }}</td>
          <td class="text-right">{{ formatPercent(record.spp_rate) }}</td>
          <td class="text-right">{{ formatPercent(record.vpp_rate) }}</td>
          <td>{{ record.tax_formula }}</td>
          <td class="text-center">
            <i
              class="fas fa-circle"
              :class="record.is_active ? 'text-success' : 'text-secondary'"
            ></i>
          </td>
          <td class="text-center">
            <a
              v-if="canUpdate"
              href="#"
              class="text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData" />
      </div>
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('importTaxModel.pageTitle')"
        centered
        :footer="null"
        width="520px"
        @cancel="clearEdit"
      >
        <form-action @cancel="clearEdit" @fetchData="fetchData" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormAction from './form'

export default {
  name: 'ImportTaxModel',
  components: { FormAction },
  data() {
    return { loading: false, showForm: false }
  },
  computed: {
    ...mapState('setting/importTaxModel', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.setting.importTaxModel.search
      },
      set(value) {
        this.$store.commit('setting/importTaxModel/SET_SEARCH', value)
        this.$store.commit('setting/importTaxModel/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('importTaxModel.model') },
        { name: this.$t('importTaxModel.hsCode') },
        { name: this.$t('importTaxModel.cppRate'), style: 'text-align:right' },
        { name: this.$t('importTaxModel.sppRate'), style: 'text-align:right' },
        { name: this.$t('importTaxModel.vppRate'), style: 'text-align:right' },
        { name: this.$t('importTaxModel.taxFormula') },
        { name: this.$t('importTaxModel.isActive'), style: 'text-align:center' },
        { name: this.$t('actions'), style: 'text-align:center;width:1px' }
      ]
    },
    canCreate() {
      return this.$store.getters.permissions.includes('create-import-tax-models')
    },
    canUpdate() {
      return this.$store.getters.permissions.includes('update-import-tax-models')
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      return this.$store
        .dispatch('setting/importTaxModel/fetch', { ...attributes })
        .catch(error => this.$toasted.error(error.message))
        .finally(() => (this.loading = false))
    },
    edit(record) {
      this.$store.commit('setting/importTaxModel/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit() {
      this.$store.commit('setting/importTaxModel/SET_EDIT_DATA', {})
      this.showForm = false
    },
    formatPercent(rate) {
      return `${Number(rate) * 100}%`
    }
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('setting/importTaxModel/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => vm.fetchData())
  }
}
</script>
